import { useState } from "react";
import { PubMemberDto } from "../../../../api/member";
import SearchMember from "../search-member";
import {
  DepositPopupWrapper,
  DepositMemberWrapper,
  DepositMember,
  DepositContentWrapper,
  DepositPaymentItem,
  DepositPaymentList,
  DepositPaymentWrapper,
} from "./style";
import { Title } from "../../../../styles/page";
import { ButtonGroup } from "../../style/popup";
import { Const } from "../../../../common/const/const";
import { PaymentMethod } from "../../../../api/settlement";
import { getPayTypeText } from "../../utils/settlement.util";
import { exchangePoint, extractDigits } from "../../../../utils/number";
import { depositPay } from "../../../../api/pub-point";
import { useRecoilValue } from "recoil";
import { pubState } from "../../../../recoil/pub.atom";
import DepositLog from "./style/components/deposit-log";

interface DepositPopupProps {
  onClose: () => void;
}

interface PaymentDto {
  amount: number;
  paymentMethod: PaymentMethod;
}

const DepositPopup = ({ onClose }: DepositPopupProps) => {
  const pub = useRecoilValue(pubState);
  const [member, setMember] = useState<PubMemberDto | null>(null);
  const [isLog, setIsLog] = useState<boolean>(false);
  const [memo, setMemo] = useState<string>("");
  const [deposit, setDeposit] = useState<number>(0);
  const [payments, setPayments] = useState<PaymentDto[]>([
    {
      amount: 0,
      paymentMethod: PaymentMethod.CASH,
    },
    {
      amount: 0,
      paymentMethod: PaymentMethod.CARD,
    },
    {
      amount: 0,
      paymentMethod: PaymentMethod.BANK_TRANSFER,
    },
  ]);
  const totalPayment = payments.reduce(
    (acc, payment) => acc + payment.amount,
    0,
  );

  const handlePayment = async () => {
    const isNotTenThousandUnit = totalPayment % 10000 !== 0;
    if (isNotTenThousandUnit) {
      alert("총 결제 금액은 만단위여야합니다. ");
      return;
    }

    if (!member || !pub) return;
    if (!memo) {
      alert("메모를 입력해주세요.");
      return;
    }
    if (!totalPayment) {
      alert("결제금액을 입력해주세요. ");
      return;
    }
    if (!deposit) {
      alert("지급 매장이용권을 입력해주세요.");
      return;
    }

    try {
      const requestPayments = payments.filter((p) => p.amount > 0);

      await depositPay({
        memberId: member.memberId,
        pubId: pub.id,
        point: deposit * Const.POINT_RATE,
        memo,
        payments: requestPayments,
      });
      alert("지급이 완료되었습니다.");
      onClose();
    } catch (e: any) {
      alert(e.message);
    }
  };

  if (isLog)
    return <DepositLog onClose={() => setIsLog(false)} member={member} />;

  return (
    <DepositPopupWrapper>
      <Title size={20}>{!member ? "닉네임 검색" : "주류마일리지 구매"}</Title>
      {!member ? (
        <SearchMember setSelectMember={setMember} selectMember={member} />
      ) : (
        <DepositContentWrapper>
          <DepositMemberWrapper>
            <DepositMember>
              <div className="member">{member.nickname}</div>
              <div className="log" onClick={() => setIsLog(true)}>
                지급 내역 확인하기
              </div>
            </DepositMember>
            <div className="point">
              보유 포인트 <span>{exchangePoint(member.point)}E</span>
            </div>
          </DepositMemberWrapper>
          <DepositPaymentWrapper>
            <div className="payment">
              결제방식 ({totalPayment.toLocaleString()}원 /{" "}
              {deposit.toLocaleString()}E)
            </div>
            <DepositPaymentList>
              {payments.map((payment, index) => (
                <DepositPaymentItem key={index}>
                  <div className="method">
                    {getPayTypeText(payment.paymentMethod)}
                  </div>
                  <input
                    value={payment.amount?.toLocaleString()}
                    onChange={(e) => {
                      const amount = extractDigits(e.target.value);
                      setPayments((prev) => {
                        const newPayments = [...prev];
                        newPayments[index].amount = amount;
                        return newPayments;
                      });
                    }}
                  />
                </DepositPaymentItem>
              ))}
              <DepositPaymentItem>
                <div className="method">지급 이용권(E)</div>
                <input
                  value={deposit.toLocaleString()}
                  onChange={(e) => setDeposit(extractDigits(e.target.value))}
                />
              </DepositPaymentItem>
              <DepositPaymentItem className="memo">
                <div className="method">메모</div>
                <input
                  placeholder="메모를 입력해주세요."
                  value={memo}
                  onChange={(e) => setMemo(e.target.value)}
                />
              </DepositPaymentItem>
            </DepositPaymentList>
          </DepositPaymentWrapper>
        </DepositContentWrapper>
      )}
      <ButtonGroup>
        <div className="button purple" onClick={handlePayment}>
          저장
        </div>
        <div className="button" onClick={onClose}>
          취소
        </div>
      </ButtonGroup>
    </DepositPopupWrapper>
  );
};

export default DepositPopup;
